<template>
  <p :class="classes" v-bind="$attrs"><slot></slot></p>
</template>

<script>
export default {
  name: "M4Hint",
  props: {
    variant: {
      type: String
    }
  },
  computed: {
    classes() {
      let classes = ["hint"];
      if (this.variant) {
        classes.push("hint--" + this.variant);
      }
      return classes;
    }
  }
};
</script>
